import { type ReactElement, type ReactNode } from 'react'

export const erxBonusLandingPageTextAccent = (
  text: ReactNode[],
): ReactElement => <span className="italic text-dark-accent">{text}</span>

export const erxBonusLandingPageTextBreak = (): ReactElement => <br />
